import { MenuDefaultProps, ModCfMenu } from "../types";
import MenuNav from "./MenuNav";
import React from "react";

const Menu = ({ data }: MenuDefaultProps) => {
  return <MenuNav menu={data} currentLevel={0} />;
};

export default Menu;
